import React from "react";
import Paper from "material-ui/Paper";

export default () => (
  <div>
    <Paper className={"paper-container"}>
      <p>
        The program was written at Biomolecular Modelling Group (link:{" "}
        <a href="http://setnylab.cent.uw.edu.pl">
          http://setnylab.cent.uw.edu.pl
        </a>) at the Centre of New Technologies of the University of Warsaw.{" "}
        <br />
      </p>
      <p>
        Please contact Piotr Setny (mail: p.setny@cent.uw.edu.pl) with any
        questions.
      </p>
    </Paper>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/about.js